import { render, staticRenderFns } from "./Stammdaten.vue?vue&type=template&id=30bdf94a&scoped=true&"
import script from "./Stammdaten.vue?vue&type=script&lang=js&"
export * from "./Stammdaten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bdf94a",
  null
  
)

export default component.exports